//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[],[[["current"],"Cut",{},1,0],[["current"],"Copy",{},1,0],[["current"],"Paste",{},1,0],[["current"],"PasteBefore",{},1,0],[["indices"],"Delete",{},1,0],[["moveTobeMoved","targetmove","moveOption"],"Move",{},3,0]],[]];
SPLM.CAM.ObjectContainer = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ObjectContainer";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ObjectContainer.MoveOption = Object.freeze({
    "After" : "After", "Before" : "Before", "Inside" : "Inside"});

export default SPLM;